// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ta-settings-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-tertiary);
}

.ta-settings-section-title {
  padding: 10px 16px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-tertiary);
  text-align: left;
}

.ta-selected-section {
  display: flex;
  flex-direction: column;
}

.ta-selected-block {
  border-bottom: 1px solid var(--border-tertiary);
}

.ta-selected-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  text-align: left;
}

.ta-selected-name {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  text-align: left;
}

.ta-selected-period {
  color: var(--text-secondary);
  flex-shrink: 0;
}

.ta-selected-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ta-collapse-toggle-up {
  transform: rotate(180deg);
}

.ta-settings-content {
  padding: 8px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px dashed var(--border-tertiary);
}

.ta-settings-content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.ta-settings-label {
  color: var(--text-secondary);
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.ta-settings-row {
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.ta-number-input {
  width: 60px;
  height: 34px;
  padding: 2px 8px;
  border: 1px solid var(--input-border);
  border-radius: 4px;
  font-size: 14px;
  text-align: left;
  background-color: var(--surface-tertiary);
  color: var(--text-primary);
  outline: none;
}

.ta-number-input:focus {
  border-color: var(--color-brand);
}

.ta-number-input::-webkit-outer-spin-button,
.ta-number-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.ta-number-input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.ta-color-swatch-common {
  margin-left: auto;
}

.ta-available-section {
  display: flex;
  flex-direction: column;
}

.ta-available-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-tertiary);
}

.ta-available-header span {
  white-space: nowrap;
  color: var(--text-primary);
}

.ta-search-input {
  flex: 1;
  min-width: 0;
  padding: 6px 10px;
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  font-size: 14px;
  background: var(--surface-primary);
  color: var(--text-primary);
  outline: none;
}

.ta-search-input:focus {
  border-color: var(--color-brand);
}

.ta-search-input::placeholder {
  color: var(--text-label);
}

.ta-category-list {
  display: flex;
  flex-direction: column;
}

.ta-category-group {
  display: flex;
  flex-direction: column;
}

.ta-category-title {
  padding: 10px 16px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-tertiary);
  text-align: left;
}

.ta-category-items {
  display: flex;
  flex-direction: column;
}

.ta-available-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px 10px 24px;
  cursor: pointer;
  text-align: left;
  user-select: none;
  transition: background 0.12s;
}

.ta-available-item:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.ta-available-item-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.ta-add-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: var(--text-primary);
}

.ta-add-icon svg {
  width: 20px;
  height: 20px;
}

.ta-add-icon-added {
  color: var(--color-brand);
}

.ta-no-results {
  padding: 16px;
  text-align: center;
  color: var(--text-label);
}

.ta-checkbox {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: var(--color-brand);
  cursor: pointer;
}

.ta-settings-field-label {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  color: var(--text-primary);
}

.ta-select-input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  font-size: 14px;
  background: var(--surface-primary);
  color: var(--text-primary);
  outline: none;
  cursor: pointer;
}

.ta-select-input:focus {
  border-color: var(--color-brand);
}

.ta-swatch-spacer {
  width: 34px;
  flex-shrink: 0;
  margin-left: auto;
}

.ta-color-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-left: auto;
}

.ta-color-label {
  font-size: 10px;
  line-height: 1;
  color: var(--text-secondary);
  text-align: center;
}

.ta-pane-height-row {
  margin-top: 8px;
  padding-top: 8px;
}

.ta-checkbox-indent {
  width: 24px;
  flex-shrink: 0;
}

@container (max-width: 600px) {
  .ta-settings-popup {
    width: 100%;
  }
}

.ta-settings-row--disabled .ta-settings-field-label {
  opacity: 0.45;
}

.ta-settings-row--disabled .ta-number-input,
.ta-settings-row--disabled .ta-color-swatch-common {
  opacity: 0.35;
  pointer-events: none;
}

.ta-color-header-row {
  justify-content: flex-end;
  padding: 0 0 4px;
}

.ta-color-header-row .ta-settings-field-label {
  flex: 1;
}

.ta-color-header-spacer {
  width: 60px;
  flex-shrink: 0;
}

.ta-color-header-row .ta-color-label {
  width: 32px;
  text-align: center;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/TechnicalAnalysisSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".ta-settings-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.ta-settings-section-title {\n  padding: 10px 16px;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-tertiary);\n  text-align: left;\n}\n\n.ta-selected-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.ta-selected-block {\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.ta-selected-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  text-align: left;\n}\n\n.ta-selected-name {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  text-align: left;\n}\n\n.ta-selected-period {\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.ta-selected-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ta-collapse-toggle-up {\n  transform: rotate(180deg);\n}\n\n.ta-settings-content {\n  padding: 8px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border-top: 1px dashed var(--border-tertiary);\n}\n\n.ta-settings-content-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0;\n}\n\n.ta-settings-label {\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n}\n\n.ta-settings-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-align: left;\n}\n\n.ta-number-input {\n  width: 60px;\n  height: 34px;\n  padding: 2px 8px;\n  border: 1px solid var(--input-border);\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: left;\n  background-color: var(--surface-tertiary);\n  color: var(--text-primary);\n  outline: none;\n}\n\n.ta-number-input:focus {\n  border-color: var(--color-brand);\n}\n\n.ta-number-input::-webkit-outer-spin-button,\n.ta-number-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.ta-number-input[type='number'] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.ta-color-swatch-common {\n  margin-left: auto;\n}\n\n.ta-available-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.ta-available-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.ta-available-header span {\n  white-space: nowrap;\n  color: var(--text-primary);\n}\n\n.ta-search-input {\n  flex: 1;\n  min-width: 0;\n  padding: 6px 10px;\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  font-size: 14px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  outline: none;\n}\n\n.ta-search-input:focus {\n  border-color: var(--color-brand);\n}\n\n.ta-search-input::placeholder {\n  color: var(--text-label);\n}\n\n.ta-category-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.ta-category-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.ta-category-title {\n  padding: 10px 16px;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-tertiary);\n  text-align: left;\n}\n\n.ta-category-items {\n  display: flex;\n  flex-direction: column;\n}\n\n.ta-available-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px 10px 24px;\n  cursor: pointer;\n  text-align: left;\n  user-select: none;\n  transition: background 0.12s;\n}\n\n.ta-available-item:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.ta-available-item-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.ta-add-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: var(--text-primary);\n}\n\n.ta-add-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ta-add-icon-added {\n  color: var(--color-brand);\n}\n\n.ta-no-results {\n  padding: 16px;\n  text-align: center;\n  color: var(--text-label);\n}\n\n.ta-checkbox {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  accent-color: var(--color-brand);\n  cursor: pointer;\n}\n\n.ta-settings-field-label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  /* overflow: hidden; */\n  text-overflow: ellipsis;\n  color: var(--text-primary);\n}\n\n.ta-select-input {\n  width: 80px;\n  padding: 6px 8px;\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  font-size: 14px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  outline: none;\n  cursor: pointer;\n}\n\n.ta-select-input:focus {\n  border-color: var(--color-brand);\n}\n\n.ta-swatch-spacer {\n  width: 34px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.ta-color-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  margin-left: auto;\n}\n\n.ta-color-label {\n  font-size: 10px;\n  line-height: 1;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.ta-pane-height-row {\n  margin-top: 8px;\n  padding-top: 8px;\n}\n\n.ta-checkbox-indent {\n  width: 24px;\n  flex-shrink: 0;\n}\n\n@container (max-width: 600px) {\n  .ta-settings-popup {\n    width: 100%;\n  }\n}\n\n.ta-settings-row--disabled .ta-settings-field-label {\n  opacity: 0.45;\n}\n\n.ta-settings-row--disabled .ta-number-input,\n.ta-settings-row--disabled .ta-color-swatch-common {\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n.ta-color-header-row {\n  justify-content: flex-end;\n  padding: 0 0 4px;\n}\n\n.ta-color-header-row .ta-settings-field-label {\n  flex: 1;\n}\n\n.ta-color-header-spacer {\n  width: 60px;\n  flex-shrink: 0;\n}\n\n.ta-color-header-row .ta-color-label {\n  width: 32px;\n  text-align: center;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
